function InitializeParticipant(nameShadowColor: string): void {
    const participantNameElement = ById<HTMLElement>("participant-name");
    participantNameElement.style.textShadow = `0 0 1px ${nameShadowColor}, 0 0 2px ${nameShadowColor}, 0 0 3px ${nameShadowColor}, 0 0 3px ${nameShadowColor}`;
}

function GetRound(): void {
    jQuery.ajax({
        type: "GET",
        url: "/Round/GetRound",
        async: true,
        data: {
            roomKey: RoomKey()
        },
        success: OfferRound
    });
}

function SetRoundDetails(roundNumber: number, participants: Participant[], elements: ElementInfo[], participantRole: Role): void {
    participants = participants.slice().sort((a, b) => {
        const tierDifference = InitiativeSortTier(a) - InitiativeSortTier(b);
        if (tierDifference !== 0) {
            return tierDifference;
        }

        return a.initiative - b.initiative;
    });

    const playersInfoElement = ById<HTMLElement>("playersInfo");
    playersInfoElement.innerHTML = "";
    const showInitiatives = participants.every(x => x.initiativeLocked);

    for (let i = 0; i < participants.length; i++) {
        const currentParticipant = participants[i];
        const currentPlayerDiv = document.createElement('div') as ParticipantRow;
        currentPlayerDiv.className = "player-row";
        currentPlayerDiv.style.backgroundColor = currentParticipant.primaryHexColor;
        currentPlayerDiv.participant = currentParticipant;
        currentPlayerDiv.addEventListener('click', ApplyConditionFunction, false);

        if (currentParticipant.isDead) {
            currentPlayerDiv.classList.add("player-row--dead");
        }

        const currentPlayerDivName = document.createElement('div');
        currentPlayerDivName.className = "participant-initiative-name";
        if (currentParticipant.role === Role.Monster) {
            currentPlayerDivName.classList.add("participant-initiative-name--monster");
        }
        currentPlayerDivName.innerText = currentParticipant.name;

        const roleIcon = BuildRoleIcon(currentParticipant);
        if (roleIcon !== null) {
            currentPlayerDivName.prepend(roleIcon);
        }

        const currentPlayerDivInitiative = document.createElement('div');
        currentPlayerDivInitiative.innerText = currentParticipant.name;

        if ((participantRole === Role.DungeonMaster || participantRole === currentParticipant.role || showInitiatives) && currentParticipant.initiative !== 0) {
            currentPlayerDivInitiative.innerText = String(currentParticipant.initiative);
        } else {
            currentPlayerDivInitiative.innerText = currentParticipant.initiativeLocked && currentParticipant.initiative !== 0 ? "?" : "..";
        }

        if (currentParticipant.isDead) {
            // The pinned initiative is only there to sort the dead to the bottom, so showing the number
            // would be reading a sentinel out of the row. The skull takes the slot instead.
            currentPlayerDivInitiative.innerText = "";
            currentPlayerDivInitiative.append(BuildDeathIcon());
            currentPlayerDivInitiative.className = "initiative-text initiative-text--dead";
        } else if (currentParticipant.initiativeLocked) {
            currentPlayerDivInitiative.className = "initiative-text_glowing";

            currentPlayerDiv.classList.add("player-row--locked");
        } else {
            currentPlayerDivInitiative.className = "initiative-text";
        }
        currentPlayerDiv.append(currentPlayerDivName);

        // Everything that is not the name lives on the right, in reading order conditions -> hit points ->
        // initiative, so hit points sit glued to the initiative number they explain instead of drifting
        // toward the name.
        const currentPlayerDivRight = document.createElement('div');
        currentPlayerDivRight.className = "participant-right";

        if (currentParticipant.conditions.length > 0) {
            currentPlayerDivRight.append(BuildConditionIcons(currentParticipant.conditions));
        }

        // Hit points ride along in the row so the table answers "who is nearly down" at a glance. Experience
        // deliberately does not - it changes once a scenario and would only crowd the row. A group with
        // standees shows them per standee instead, while a player keeps their own next to their summons.
        if (HasTrackerValue(currentParticipant.hitPoints) && (currentParticipant.enemies.length === 0 || currentParticipant.role !== Role.Monster)) {
            currentPlayerDivRight.append(BuildHitPointBar(currentParticipant.hitPoints, currentParticipant.maxHitPoints));
        }

        // A monster group carries its first pair of standees in its own row, beside the initiative.
        let enemyRows = ChunkEnemies(SortEnemies(currentParticipant.enemies));
        let inlineCells: HTMLDivElement | null = null;
        if (currentParticipant.role === Role.Monster && enemyRows.length > 0) {
            inlineCells = BuildEnemyCells(currentParticipant, enemyRows[0]);
            currentPlayerDivRight.append(inlineCells);
            enemyRows = enemyRows.slice(1);
        }

        currentPlayerDivRight.append(currentPlayerDivInitiative);
        currentPlayerDiv.append(currentPlayerDivRight);

        playersInfoElement.append(currentPlayerDiv);

        if (inlineCells !== null && EnemyCellsDoNotFit(currentPlayerDiv)) {
            inlineCells.remove();
            inlineCells = null;
            enemyRows = ChunkEnemies(SortEnemies(currentParticipant.enemies));
        }

        for (const enemyRow of enemyRows) {
            playersInfoElement.append(BuildEnemyRow(currentParticipant, enemyRow, inlineCells === null));
        }

        ResetInitiativeLock(currentParticipant);
    }

    playersInfoElement.lastElementChild?.classList.add("player-row--last");

    const elementsInfoElement = ById<HTMLElement>("elementsInfo");
    elementsInfoElement.innerHTML = "";

    const addElementButton = document.createElement('button');
    addElementButton.type = "button";
    addElementButton.className = "element-add-button";
    addElementButton.innerText = "+";
    addElementButton.onclick = () => ActivateElementFunction();
    elementsInfoElement.append(addElementButton);

    for (let i = 0; i < elements.length; i++) {
        const currentElement = elements[i];

        if (currentElement.roundsRemaining === 0) {
            continue;
        }

        const currentElementDiv = document.createElement('div');
        currentElementDiv.style.backgroundColor = currentElement.color;
        currentElementDiv.className = "element-info";
        currentElementDiv.innerText = currentElement.elementType;
        currentElementDiv.prepend(BuildElementIcon(currentElement.elementType));
        currentElementDiv.onclick = () => UseElementFunction(currentElement.elementType, currentElement.color);
        if (currentElement.elementType === ElementType.Dark) {
            currentElementDiv.classList.add("element-info--dark");
        }

        const roundsRemainingDiv = document.createElement('span');
        roundsRemainingDiv.className = "element-rounds-dot";

        if (currentElement.roundsRemaining === 2) {
            roundsRemainingDiv.classList.add("element-rounds-dot--fresh");
        }
        if (currentElement.roundsRemaining === 1) {
            roundsRemainingDiv.classList.add("element-rounds-dot--last-round");
        }
        currentElementDiv.append(roundsRemainingDiv);

        elementsInfoElement.append(currentElementDiv);
    }

    ById<HTMLElement>("roundNumber").innerHTML = String(roundNumber);

    RenderTrackers(participants);
}

// Read the table from the bottom: the dead sit under everyone, a long rest sits above them, and the rest is
// the initiative order itself with whoever has not picked yet at its foot. The dead are tiered on being
// dead rather than on a sentinel initiative, so nobody has to read a fake number out of the row.
function InitiativeSortTier(participant: Participant): number {
    if (participant.isDead) {
        return 3;
    }

    if (participant.initiative >= MaxInitiative) {
        return 2;
    }

    if (!participant.initiative) {
        return 1;
    }

    return 0;
}

// Without a maximum there is no ratio, so the number carries a plain halo rather than one that would have
// to guess how hurt somebody is.
function BuildHitPointBar(currentHitPoints: number | null, maxHitPoints: number | null): HTMLDivElement {
    const chip = document.createElement('div');
    chip.className = "participant-hit-points";

    const max = HasTrackerValue(maxHitPoints) && maxHitPoints > 0 ? maxHitPoints : null;
    const hitPoints = currentHitPoints ?? 0;
    const ratio = max ? Math.min(1, Math.max(0, hitPoints / max)) : null;

    const value = document.createElement('span');
    value.className = "participant-hit-points__value";
    value.innerText = max ? hitPoints + "/" + max : String(hitPoints);
    value.style.textShadow = HitPointGlow(ratio);
    chip.append(value);

    return chip;
}

// The health is in the glow rather than in a bar: white text with a tight green halo at full health, and as
// the hit points drop the halo slides round to red and spreads out. Being continuous, it reads as "hurt"
// long before you get to the number, and it does not need a row of its own.
function HitPointGlow(ratio: number | null): string {
    if (ratio === null) {
        return "0 0 3px rgba(255, 255, 255, 0.75)";
    }

    const color = "hsl(" + (120 * ratio) + ", 100%, 45%)";
    const spread = 3 + (1 - ratio) * 9;

    return `0 0 ${spread * 0.35}px ${color}, 0 0 ${spread}px ${color}, 0 0 ${spread * 2}px ${color}`;
}

function BuildConditionIcons(conditions: Condition[]): HTMLDivElement {
    const conditionsElement = document.createElement('div');
    conditionsElement.className = "participant-conditions";

    for (const condition of conditions) {
        if (condition.roundsRemaining <= 0)
            continue;

        const conditionElement = document.createElement('div');
        conditionElement.className = "participant-condition";

        const statusImage = document.createElement('img');
        statusImage.className = "participant-status-icon";
        statusImage.src = "status-icons/" + condition.conditionType + ".png";
        conditionElement.append(statusImage);

        if (condition.roundsRemaining > 2) {
            conditionElement.classList.add("participant-condition--fresh");
        }
        if (condition.roundsRemaining === 2) {
            conditionElement.classList.add("participant-condition--fading");
        }
        if (condition.roundsRemaining === 1) {
            conditionElement.classList.add("participant-condition--last-round");
        }
        conditionsElement.append(conditionElement);
    }

    return conditionsElement;
}

function BuildDeathIcon(): HTMLDivElement {
    const deathIcon = document.createElement('div');
    deathIcon.className = "participant-death-icon";
    deathIcon.innerText = "💀";

    return deathIcon;
}
